import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../features/app-setting/redux/actions';
import AceEditor from 'react-ace';
import 'ace-builds/src-noconflict/mode-javascript';
import 'ace-builds/src-noconflict/theme-monokai';
import { toast } from 'react-toastify';
import CustomLoader from '../common/CustomLoader';
export class CssCodeEditor extends Component {
  static propTypes = {
    appSetting: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    editorvalue: '',
    isEditing: false,
  };

  handleCustomCssCdnDelete = async () => {
    const { appSetting, actions } = this.props;
    const { projectId, version } = this.props;

    try {
      await actions.deleteProjectCustomCssUrl({
        projectId: projectId,
        version: version,
        uuid: appSetting.cssUuid,
        noToast: true,
      });
      console.log('Custom CSS file deleted successfully');
    } catch (error) {
      console.error('Error deleting custom CSS file:', error);
    }
  };

  saveCSSFile = async () => {
    const { appSetting, actions, projectId, version } = this.props;
    const { urlOrTag } = appSetting.customCssCdnData;
    const endName = urlOrTag.split('/').pop();
    console.log('/' + endName);

    const cssContent = this.state.isEditing ? this.state.editorvalue : appSetting.cssEditorValue;
    const blob = new Blob([cssContent], { type: 'text/css' });
    const formData = new FormData();
    formData.append('file', blob, `${appSetting.cssUuid}/${endName}`);
    formData.append('customCssCdnData', JSON.stringify(appSetting.customCssCdnData));
    await actions.saveCssFile({
      projectId: projectId,
      version,
      cssUuid: appSetting.cssUuid,
      formData: formData,
      customCssCdnData: appSetting.customCssCdnData,
    });
  };

  handleSave = async () => {
    await this.handleCustomCssCdnDelete();
    await this.saveCSSFile();
    const { projectId, actions, version } = this.props;
    actions.loadCustomCssCdns({ projectId, version });
    toast.success('Css file Updated Successfully !');
    actions.toggleCssEditorModal();
  };

  handleStartEditing = () => {
    this.setState({ isEditing: true, editorvalue: this.props.appSetting.cssEditorValue });
  };

  handleChange = (value) => {
    if (this.state.isEditing) {
      this.setState({ editorvalue: value });
    }
  };
  handleCancel = () => {
    const { actions } = this.props;
    actions.toggleCssEditorModal();
  };
  render() {
    const { appSetting } = this.props;
    const { projectId } = this.props;
    const { deleteProjectCustomCssUrlPending, saveCssFilePending, loadCustomCssCdnsPending } =
      appSetting;
    const value = this.state.isEditing ? this.state.editorvalue : appSetting.cssEditorValue;
    return (
      <div className="cssEditorui">
        <div className="row">
          <div className="col-md-12 col-lg-12 col-sm-12">
            <AceEditor
              mode="javascript"
              theme="github"
              value={value}
              name="code-editor1"
              width="100%"
              height="60vh"
              fontSize={15}
              wrapEnabled={true}
              showPrintMargin={false}
              readOnly={!this.state.isEditing}
              onChange={this.handleChange}
              onFocus={this.handleStartEditing}
            />
          </div>
        </div>
        <div className="d-flex justify-content-between align-items-center">
          <button
            className="btn btn-outline-secondary btn-md"
            title="Cancel"
            onClick={this.handleCancel}
          >
            <i className="wb webconnect-times"></i> Cancel
          </button>

          <button
            className="btn btn-theme-submit btn-md"
            title="Update"
            onClick={this.handleSave}
            disabled={
              deleteProjectCustomCssUrlPending || saveCssFilePending || loadCustomCssCdnsPending
            }
          >
            <i className="wb webconnect-save-regular"></i> Update
            <CustomLoader
              loading={
                deleteProjectCustomCssUrlPending || saveCssFilePending || loadCustomCssCdnsPending
              }
            />
          </button>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    appSetting: state.appSetting,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CssCodeEditor);
